import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import KapeiLogo from "@/components/KapeiLogo";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import PasswordInput from "@/components/PasswordInput";
import api from "@/lib/api";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";

  const [password, setPassword] = useState("");
  const [repeat, setRepeat] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr("");

    if (!token) {
      setErr("Falta el token de recuperación.");
      return;
    }

    if (password.length < 8) {
      setErr("La contraseña debe tener mínimo 8 caracteres.");
      return;
    }

    if (password !== repeat) {
      setErr("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);
    try {
      await api.post("/auth/reset-password", {
        token,
        new_password: password,
      });
      toast.success("Contraseña cambiada");
      navigate("/login");
    } catch (e2) {
      setErr(e2.response?.data?.detail || "No se pudo cambiar la contraseña.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="mx-auto flex min-h-screen max-w-md flex-col px-6 py-6">
        <Link to="/"><KapeiLogo className="mb-8" /></Link>

        <h1 className="mb-2 text-4xl font-black tracking-tight text-slate-900">
          Nueva contraseña
        </h1>

        <p className="mb-8 text-base text-slate-600">
          Crea una nueva contraseña para tu cuenta KAPEI.
        </p>

        <form onSubmit={onSubmit} className="flex flex-col gap-5">
          <div>
            <Label className="text-sm font-bold uppercase tracking-widest text-slate-700">
              Nueva contraseña
            </Label>
            <PasswordInput
              data-testid="reset-password"
              required
              minLength={8}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-2 h-14 rounded-xl border-2 border-slate-300 px-4 text-lg"
              placeholder="Mínimo 8 caracteres"
            />
          </div>

          <div>
            <Label className="text-sm font-bold uppercase tracking-widest text-slate-700">
              Repetir contraseña
            </Label>
            <PasswordInput
              data-testid="reset-repeat"
              required
              minLength={8}
              value={repeat}
              onChange={(e) => setRepeat(e.target.value)}
              className="mt-2 h-14 rounded-xl border-2 border-slate-300 px-4 text-lg"
            />
          </div>

          {err && (
            <div className="rounded-xl bg-red-50 p-3 text-sm font-bold text-red-700">
              {err}
            </div>
          )}

          <Button
            data-testid="reset-submit"
            type="submit"
            disabled={loading}
            className="kapei-btn-huge bg-[#4d7c0f] text-white hover:bg-[#3f6212]"
          >
            {loading ? "Guardando…" : "Cambiar contraseña"}
          </Button>
        </form>
      </div>
    </div>
  );
}
